import { constants } from "../constants/redux-constants";

const initialState = {
  tasks: [],
  showTaskInProgressPopup: false
};

export default function BackgroundtaskReducer(state = initialState, action) {
  switch (action.type) {


    case constants.BACKGROUND_TASKS.MARK_AS_READ:
      return {
        ...state,
        tasks: state.tasks.map((task) =>
          task.id === action.payload
            ? { ...task, isRead: true }
            : task
        ),
      };

    case constants.BACKGROUND_TASKS.MARK_FAILED_AS_READ:
      return {
        ...state,
        tasks: state.tasks.map((task) =>
          task.status === "FAILED" ? { ...task, isRead: true } : task
        ),
      };

    case constants.BACKGROUND_TASKS.REMOVE_ACTIVE_TASKS:
      return {
        ...state,
        tasks: state.tasks.filter(
          (task) => !['IN_PROGRESS', 'QUEUED'].includes(task.status)
        ),
      };

    case constants.BACKGROUND_TASKS.SHOW_TASK_INPROGRESS_POPUP:
      return {
        ...state,
        showTaskInProgressPopup: action.payload,
      };
    default:
      return state;
  }
}